import React from 'react';
import xhr from 'xhr';
import xtend from 'xtend';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom'

import WorkspaceStore from '../flux/stores/WorkspaceStore';
import WorkspaceActions from '../flux/WorkspaceActions';

/**
 * @fixme ???
 * TimerMixin
 */
import TimerMixin from '../../mixins/Timer';

import Snack from './SnackMessage';

class InteractionProtection extends React.Component {
    constructor (props) {
        super(props)
        this.state = xtend(WorkspaceStore.getState(), {
            snackMsg: false
        })
    }

    componentWillMount () {
        WorkspaceStore.addChangeListener(this.onChange);
    }

    componentWillUnmount () {
        WorkspaceStore.removeChangeListener(this.onChange);
    }

    onChange () {
        this.setState(
            xtend(
                this.state,
                WorkspaceStore.getState()
            )
        );
    }

    componentDidMount () {
        // Intervals of 15 minutes
        this && this.timerStart && this.timerStart(900);
    }

    heartbeat () {
        var self = this;
        xhr({
            method: 'POST',
            uri: "/admin/heartbeat",
            body: JSON.stringify({}),
            headers: {
                "Content-Type": "application/json"
            }
        }, function (err, resp, body) {
            if (resp.statusCode == 401 && body) {
                try {
                    var parsed = JSON.parse(body);
                    self.props.emitSnack({
                        type: 'error',
                        message: parsed.errors.message
                    });
                } catch (e) {
                    console.warn(e);
                    parsed = false;
                } finally {
                    WorkspaceActions.haltApplication({
                        type: 'session:close',
                        data: parsed ? parsed : body
                    });
                }
            } else if (resp.statusCode == 200) {
                // Do nothing as the session was validated!
                // console.info('Heartbeat %o', parsed);
            } else if (resp.statusCode == 500) {
                try {
                    var parsed = JSON.parse(body);
                    var { errors } = parsed;
                    if (errors.hasError) {
                        self.setState({
                            snackMsg: (<span>
                                Could not verify Google Credentials.
                                <Link to="/help">Please read the Documentation on how to fix this.</Link>
                            </span>)
                        });
                    }
                } catch (e) {
                    console.warn(e);
                }
            }
        });
    }

    timerCallback () {
        this.heartbeat();
    }

    render () {
        if (!this.state.userIsActive) {
            var title, msg, action;

            switch (this.state.haltContext.type) {
                case 'socket:slow':
                case 'socket:error':
                case 'socket:close':
                    title = "Disconnected from Server";
                    msg = (<p className="text-danger text-center">
                        <strong>Please wait while the Application attempts to reconnect.</strong>
                        <br/>
                        <br/>
                        <i className="fa fa-cog fa-spin fa-3x fa-fw"/>
                        <br/>
                        <br/>
                        You may reload the page, or, if the issue persists, contact <a href="mailto:support@invintus.com">support@invintus.com</a>
                    </p>);
                    action = <a href={window.location.pathname} className="btn btn-primary">Reload Page</a>;
                    break;

                case 'session:close':
                    title = "Session Expired";
                    msg = <p className="text-danger">Please Login to Continue.</p>;
                    action = <a href="/login" className="btn btn-primary">Login</a>;
                    break;
            }

            return (
                <Modal animation={false} bsSize="large" show={!this.state.userIsActive} onHide={this.stub}>
                    <Modal.Header>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="alert alert-danger">{msg}</div>
                    </Modal.Body>
                    <Modal.Footer>
                        {action}
                    </Modal.Footer>
                </Modal>
            );
        } else if (this.state.snackMsg) {
            return (<Snack
                isOpen={true}
                timeout={Infinity}
                message={this.state.snackMsg}
                onClose={function noop () {}}
                type="error"
            />);
        }
        return <span/>;
    }
}

export default InteractionProtection;
